import React from 'react';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../store';
import { setGoToDashbord, setGoToTirage } from '../store/appSlice';
import { Box, Grid } from '@mui/material'
import _ from "lodash";
import { colorProfExpert } from '../util/constant';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import DashboardIcon from '@mui/icons-material/Dashboard';


export const currentYear = {
    annee: new Date().getFullYear().toString(),
}



const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const Dashbord = () => {


    //redux
    const dispatch = useDispatch()
    const goToDashbord = useSelector((state: IReduxState) => state.application.goToDashbord);

    //hooks
    const theme = useTheme();
    const lgDown = useMediaQuery(theme.breakpoints.down("lg"));


    const handleClose = () => {
        dispatch(setGoToDashbord(!goToDashbord))
    };


    return (
        <React.Fragment>
            <Dialog
                fullScreen
                open={goToDashbord}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', background: colorProfExpert }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => null}
                            aria-label="close"
                        >
                            <DashboardIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {`Tableau de bord`}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '100%',
                        maxWidth: '1000px',
                        // p: 1,
                        bgcolor: 'background.paper',
                        borderRadius: 1,
                        marginTop: lgDown ? "20px" : ""
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6} sm={6} lg={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12} sm={12} lg={12}></Grid>
                                <Grid item xs={12} md={12} sm={12} lg={12}></Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={6} sm={6} lg={6}>

                        </Grid>
                    </Grid>
                </Box>
            </Dialog>
        </React.Fragment>
    );
}
